import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["qaContainer", "uploadErrors", "uploadSuccess", "processing", "submitButton"];

  connect() {
    this.form = this.element.querySelector("form");
    if (this.form) {
      this.form.addEventListener("turbo:submit-start", this.handleSubmit.bind(this));
    }
  }

  addQuestion(event) {
    const template = document.getElementById("knowledge-question-template").content.cloneNode(true);
    this.qaContainerTarget.appendChild(template);
  }

  removeQuestion(event) {
    const question = event.target.closest(
      "[data-support-agent-onboarding--knowledge-target='questionForm']"
    );
    if (question) {
      question.remove();
    }
  }

  handleSubmit(event) {
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = true;
      this.submitButtonTarget.innerHTML = "Processing...";
      this.submitButtonTarget.classList.add("opacity-70", "cursor-not-allowed");
    }
  }

  uploadErrorsTargetConnected(target) {
    this.processingTarget.hidden = true;

    // Re-enable the button when error occurs
    if (this.hasSubmitButtonTarget) {
      this.submitButtonTarget.disabled = false;
      this.submitButtonTarget.innerHTML = "Continue";
      this.submitButtonTarget.classList.remove("opacity-70", "cursor-not-allowed");
    }
  }

  uploadSuccessTargetConnected(target) {
    window.location.href = "/admin/support_agent/onboarding?step=done";
  }
}
